(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define([], factory);
  } else if (typeof exports === 'object') {
    // Node, CommonJS-like
    module.exports = factory();
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function () {
  'use strict';

  /**
   * Singleton service for managing session storage
   *
   * @class SessionStorageService
   * @constructor
   */
  var sessionStorageService = {
    SESSION_STORAGE_KEYS: {
      /**
       * @property base {String} session storage key name to use for ereg workflow config.
       */
      eregWorkflowConfig: 'eregWorkflowConfig',
      serialNumber: 'serialNumber',
      clinicVecnaId: 'clinicVecnaId'
    },

    /**
     * Get key from the session storage
     * @method getItem
     * @param keyName {String} the name of the key you want to retrieve the value of.
     * @returns {Object} the key value parsed to object. If the key does not exist, null is returned.
     */
    getItem: function(keyName) {
      if (sessionStorageService._sessionStorageExists()) {
        var keyValue = window.sessionStorage.getItem(keyName);
        if (keyValue !== undefined && keyValue !== null) {
          return JSON.parse(keyValue);
        }
      }
      return null;
    },

    /**
     * Set a key to the session storage.
     * @param keyName {String} the name of the key you want to create or update.
     * @param keyValue {Object} the value of the key you want to create or update.
     * @method setItem
     */
    setItem: function(keyName, keyValue) {
      if (sessionStorageService._sessionStorageExists()) {
        window.sessionStorage.setItem(keyName, JSON.stringify(keyValue));
      }
    },

    /**
     * Remove key from session storage
     * @param keyName {String} the name of the key you want to remove.
     * @method removeItem
     */
    removeItem: function(keyName) {
      if (sessionStorageService._sessionStorageExists()) {
        window.sessionStorage.removeItem(keyName);
      }
    },

    /**
     * Determines whether or not the session storage is accessible.
     * @method sessionStorageExists
     * @private
     * @return {Boolean} true if the browser supports session storage, false otherwise.
     */
    _sessionStorageExists: function() {
      // Detection borrowed from: http://diveintohtml5.info/detect.html#storage
      try {
        return 'sessionStorage' in window && window.sessionStorage !== null;
      } catch (ex) {
        return false;
      }
    }
  };

  return sessionStorageService;
}));
